const acrAlertHR = {
    "form": {
        "modal": {
            "releaseCopyrightDeclaration": {
                "header": "Izjava o autorskim pravima za izdanje",
                "body": {
                    "description": "Postoji upozorenje o autorskim pravima za ovo izdanje. Označene pjesme/sadržaj su sljedeći:",
                    "table": {
                        "column": {
                            "trackName": "Naziv pjesme",
                            "type": "Tip",
                            "title": "Naslov",
                            "artists": "Umjetnici",
                            "album": "Album",
                            "label": "Izdavačka kuća",
                            "releaseDate": "Datum izdanja",
                            "releaseYear": "Godina izdanja"
                        }
                    },
                    "label": {
                        "music": "Glazba",
                        "cover": "Omot",
                        "sourceOne": "Izvor Jedan",
                        "sourceTwo": "Izvor Dva",
                        "releaseLicense": "Licenca za izdanje",
                        "proofOfPurchase": "Dokaz kupnje za sample pack",
                        "signDeclaration": "Molimo potpišite izjavu kako biste nastavili dalje.",
                        "cancelRelease": "Želim otkazati ovo izdanje.",
                        "approveRelease": "Želim odobriti ovo izdanje i razumijem i u potpunosti prihvaćam pravne posljedice ove radnje.",
                        "approveReleaseAllStores": "Želim odobriti ovo izdanje za SVE trgovine; pronađeni rezultati su 100% identični s našim umjetnikom i sadržaj pripada našem umjetniku. Razumijemo i u potpunosti prihvaćamo pravne posljedice ove radnje.",
                        "approveReleaseAllStoresCover": "Želim odobriti ovo izdanje za SVE trgovine; ovo je izdanje OMOTA za koje sam kupio LICENCU.",
                        "legitimateMusic": "Moja glazba je legitimna i ne krši nikakva prava. Koristio sam legalno kupljene sample packs.",
                        "disagreeWithResults": "Potpuno se opredijeljujem s rezultatima predstavljenima. Moja glazba je apsolutno čista. Tražim reviziju."
                    },
                    "help_text": {
                        "releaseLicense": "Molimo učitajte licencu za izdanje",
                        "legitimateMusic": "Molimo napomenite da je potrebno učitati originalnu fakturu kao dokaz kupnje za sample pack. Molimo napomenite da bilo koji pokušaj da se izbježi ili počini prevaru biti će suočen s naknadom.",
                        "proofOfPurchaseFileUpload": "Molimo učitajte dokaz kupnje za sample pack",
                        "disagreeWithResults": "Ako odaberete ovu opciju, priznajete potencijalnu naknadu od € 100 na vaš račun u slučaju da revizija otkrije podudaranja. Alati za reviziju koje koristimo biti će konačni odlučivač; bilo što podudaranje s drugim pjesmama s sličnošću iznad 5% biti će smatran nelegitimnim sadržajem. Molimo napomenite da ako kršite, lažno predstavljate ili koristite ovu opciju u lažnoj svrhi, rezerviramo pravo da neposredno prekinemo vaš račun bez povrata."
                    },
                },
                "button": {
                    "submit": "Pošalji",
                    "cancel": "Otkaži"
                }
            },
            "confirmRejection": {
                "header": "Potvrdi odbijanje",
                "body": "Odbijanjem ovog izdanja, vaše izdanje će biti ISKLJUČENO i morat ćete ga prilagoditi prije ponovnog slanja na distribuciju. Jeste li sigurni da želite to učiniti?",
                "bodyReDelivery": "Ovom radnjom vaše izdanje prelazi u status Re-Delivery Editing. Ako su izmjene uključivale i audio i metapodatke, u tom slučaju vraćaju se samo audio izmjene i morat ćete ponovno poslati uređivanje. Ako je vaše ažuriranje bilo samo audio, vaše se izdanje vraća u status Distributed. Jeste li sigurni da želite nastaviti?",
                "button": {
                    "yes": "Da",
                    "no": "Ne"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "Otkazali ste distribuciju izdanja. Ako se predomislite, morat ćete napraviti promjene na audio datoteci i ponovno je poslati na distribuciju.",
            "releaseHasCopyrightAlert": "Izdanje {{releaseName}} ima upozorenje o autorskim pravima. Molimo potpišite <4>Izjavu</4> kako biste nastavili dalje.",
            "submitEditingMetadataNote": "Audio datoteka je odbijena zbog skeniranja, no budući da su promijenjeni i metapodaci, morat ćete kliknuti Pošalji uređivanje kako biste nastavili.",
            "submitEditingMetadataAdminNote": "Audio datoteka koju želite promijeniti odbijena je od strane administratora. Ostatak metapodataka može se poslati na uređivanje.",
            "admin_pending": "Vaša izjava čeka na pregled administratora za daljnje djelovanje.",
            "admin_approved": "Vaš zahtjev za distribuciju vašeg izdanja odobren je od strane našeg administrativnog tima. Izdanje je uspješno verificirano. Cijenimo vašu marljivost u osiguravanju točnosti i usklađenosti. Izdanje će biti poslano u sve trgovine prema planu. Hvala vam na pažnji prema detaljima i pridržavanju naših standarda.",
            "admin_rejected": "Vaš zahtjev za distribuciju vašeg izdanja je odbijen. Nakon pažljivog pregleda, zahtjev ne ispunjava naše uvjete za odobrenje. Preporučujemo ponovno vrednovanje sadržaja i osiguravanje da su svi uvjeti i pravne implikacije ispunjeni. Hvala vam na razumijevanju i suradnji.",
            "button": {
                "yes": "Da",
                "no": "Ne"
            }
        }
    }
};

export default acrAlertHR;